/**
 * Extract error message from various error formats
 */
export const extractErrorMessage = (error: unknown): string => {
  // If the error is an instance of Error, return the message
  if (error instanceof Error) {
    return error.message || 'Unknown error occurred';
  }

  // If the error is a string, return the string
  if (typeof error === 'string') {
    return error;
  }

  // If the error is an object, return the stringified error
  if (error && typeof error === 'object') {
    const anyError = error as Record<string, unknown>;

    // error.body.message / error.body.error
    if (typeof anyError.body === 'object' && anyError.body !== null) {
      const body = anyError.body as Record<string, unknown>;

      if (typeof body.message === 'string') return body.message;
      if (typeof body.error === 'string') return body.error;
    }

    // error.message
    if (typeof anyError.message === 'string') {
      return anyError.message;
    }

    // error.error
    if (typeof anyError.error === 'string') {
      return anyError.error;
    }
  }

  // Last defense
  try {
    return JSON.stringify(error);
  } catch {
    return 'Unknown error occurred';
  }
};
